import * as React from 'react';
import {FormattedMessage, FormattedDate} from '@meiko/react-intl';

export default function LeadInformation({building = null, listItem}) {
	if (!listItem) {
		return null;
	}

	const listable = listItem.listable.data;

	return (
		<div>
			<div className={building ? 'text-xs' : 'text-sm'}>
				{listable?.client?.data?.firstName ?? listable.clientFirstName ?? ''}{' '}
				{listable?.client?.data?.lastName ?? listable.clientLastName ?? ''}
			</div>
			<div className="text-xs text-gray-500 flex flex-wrap gap-x-2">
				{listable?.client?.data?.email || listable.email ? (
					<span>{listable?.client?.data?.email ?? listable.email ?? ''}</span>
				) : null}
				{listable?.client?.data?.phone || listable.phone ? (
					<span>{listable?.client?.data?.phone ?? listable.phone ?? ''}</span>
				) : null}
			</div>
			{!building && (
				<div className="text-xs text-gray-500">
					<FormattedMessage id="Added" /> <FormattedDate value={listItem.createdAt} />
				</div>
			)}
		</div>
	);
}
